import { createContext, useContext } from 'react';
import { createContextProvider } from "@src/utils/ContextActions";
import AppActions from "./AppActions"

const AppContext = createContext();

export const initialState = {
    statistics: null,
    lead: null,
    isLoading: false,
    showThx: false,
};

export const AppProvider = createContextProvider(AppContext, initialState, AppActions);

/**
 * @return {[ appState: initialState, AppActions: AppActions ]}
 */
export const useAppContext = () => useContext(AppContext);